import { render, staticRenderFns } from "./VerifiedComplaintBox.vue?vue&type=template&id=16852fe0&scoped=true&"
import script from "./VerifiedComplaintBox.vue?vue&type=script&lang=js&"
export * from "./VerifiedComplaintBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16852fe0",
  null
  
)

export default component.exports